import { useEffect, useState } from 'react'

import { MenuCollapsedState } from '../../../context'
import {
  getStoredMenuCollapsedState,
  storeMenuCollapsedState,
} from '../../../utils/menu'

function MenuCollapsedStateProvider({ children }) {
  const [collapsed, setCollapsed] = useState(getStoredMenuCollapsedState())

  useEffect(() => {
    storeMenuCollapsedState(collapsed)
  }, [collapsed])

  const value = [collapsed, setCollapsed]

  return <MenuCollapsedState value={value}>{children}</MenuCollapsedState>
}

export default MenuCollapsedStateProvider
